<template>
  <ion-app>
    <ion-content>
      <Loading :active.sync="isLoading" :is-full-page="fullPage"></Loading>
      <ion-grid>
        <div :class="notification.class">
          <ion-icon mode="ios" name="alert" class="mr-2 mt-0"></ion-icon>
          <p class="mb-0 mt-0">{{ notification.message }}</p>
        </div>
        <div class="back-button-bg" @click="gotoBack">
          <ion-icon mode="ios" name="arrow-back" size="large" class="white"></ion-icon>
        </div>
        <p class="page-title">Novo peso</p>
      </ion-grid>
      <div class="edit-block-max-height mt-5">
        <label class="edit-block-padding dark bold">Novo peso</label>
        <ion-item class="form-item mb-5 mt-1 padding-input" lines="none">
          <ion-input
            type="number"
            class="weight-input"
            placeholder="60"
            :value="profile.data.weight"
            @ionInput="weight = $event.target.value"
          ></ion-input>
          <div class="form-item-unit dark">kg</div>
        </ion-item>

        <div class="edit-block-padding">
          <label class="dark bold">
            Como está o seu corpo hoje?
            <br />
            <span class="dark">(escolha o mais próximo)</span>
          </label>
          <div class="mb-5 mt-3">
            <ion-row>
              <ion-col size="3">
                <div class="mb-2 mr-1 ml-1 bf" @click="selectBF('bf1')">
                  <div :class="bf1.class">
                    <ion-img class="bf-image" :src="bfImage1"></ion-img>
                  </div>
                </div>
              </ion-col>
              <ion-col size="3">
                <div class="mb-2 mr-1 ml-1 bf" @click="selectBF('bf2')">
                  <div :class="bf2.class">
                    <ion-img class="bf-image" :src="bfImage2"></ion-img>
                  </div>
                </div>
              </ion-col>
              <ion-col size="3">
                <div class="mb-2 mr-1 ml-1 bf" @click="selectBF('bf3')">
                  <div :class="bf3.class">
                    <ion-img class="bf-image" :src="bfImage3"></ion-img>
                  </div>
                </div>
              </ion-col>
              <ion-col size="3">
                <div class="mb-2 mr-1 ml-1 bf" @click="selectBF('bf4')">
                  <div :class="bf4.class">
                    <ion-img class="bf-image" :src="bfImage4"></ion-img>
                  </div>
                </div>
              </ion-col>
            </ion-row>
          </div>
          <ion-button expand="block" mode="ios" shape="round" class="main-button" @click="saveInfo">
            <ion-icon mode="ios" name="checkmark" class="white" size="large"></ion-icon>
          </ion-button>
          <p
            class="mt-3 text-sm dark ion-text-center"
          >Sua dieta será recalculada a partir da próxima semana.</p>
        </div>
      </div>
    </ion-content>
  </ion-app>
</template>

<script>
// firebase
import db from "@/firebase/init";
import firebase from "firebase";
// loading
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// moment
import moment from "moment";
moment.locale("pt-br");
// store
import store from "@/utils/store.js";
// utils
import { calculateTargets } from "@/utils/formulas.js";
// component
export default {
  name: "EditBody",
  components: {
    Loading
  },
  data() {
    return {
      notification: {
        class: "error-message p-3 d-none",
        message: null
      },
      isLoading: false,
      fullPage: true,
      user: store.state.user,
      profile: store.state.profile,
      weight: 60,
      bf: "bf3",
      bfImage1:
        "https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/bf_woman_1.png?alt=media&token=83512766-e30d-4c71-ad3c-7a3c3ffb4bc2",
      bfImage2:
        "https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/bf_woman_2.png?alt=media&token=d4c78f7b-7c75-414d-92e3-7333a06fae9d",
      bfImage3:
        "https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/bf_woman_3.png?alt=media&token=3b8c9797-f8f2-4e4d-9a50-a0a21bd6f250",
      bfImage4:
        "https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/bf_woman_4.png?alt=media&token=7bcb23f1-2aa4-4154-be54-bf5132151ac5",
      bf1: {
        selected: false,
        class:
          "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
      },
      bf2: {
        selected: false,
        class:
          "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
      },
      bf3: {
        selected: false,
        class:
          "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
      },
      bf4: {
        selected: false,
        class:
          "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
      }
    };
  },
  methods: {
    clearNotification() {
      this.notification = {
        class: "error-message p-3 d-none",
        message: null
      };
    },
    startLoading() {
      const instance = this;
      instance.isLoading = true;
      setTimeout(() => {
        instance.loading = false;
      }, 3000);
    },
    gotoBack() {
      this.$router.go(-1);
    },
    selectBF(bf) {
      this.bf = bf;
      if (bf === "bf1") {
        this.bf1 = {
          selected: true,
          class:
            "pseudo-button pseudo-button-very-small pseudo-button-selected pt-2 pb-2 ion-text-center"
        };
        this.bf2 = {
          selected: false,
          class:
            "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
        };
        this.bf3 = {
          selected: false,
          class:
            "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
        };
        this.bf4 = {
          selected: false,
          class:
            "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
        };
      } else if (bf === "bf2") {
        this.bf1 = {
          selected: false,
          class:
            "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
        };
        this.bf2 = {
          selected: true,
          class:
            "pseudo-button pseudo-button-very-small pseudo-button-selected pt-2 pb-2 ion-text-center"
        };
        this.bf3 = {
          selected: false,
          class:
            "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
        };
        this.bf4 = {
          selected: false,
          class:
            "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
        };
      } else if (bf === "bf3") {
        this.bf1 = {
          selected: false,
          class:
            "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
        };
        this.bf2 = {
          selected: false,
          class:
            "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
        };
        this.bf3 = {
          selected: true,
          class:
            "pseudo-button pseudo-button-very-small pseudo-button-selected pt-2 pb-2 ion-text-center"
        };
        this.bf4 = {
          selected: false,
          class:
            "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
        };
      } else if (bf === "bf4") {
        this.bf1 = {
          selected: false,
          class:
            "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
        };
        this.bf2 = {
          selected: false,
          class:
            "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
        };
        this.bf3 = {
          selected: false,
          class:
            "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
        };
        this.bf4 = {
          selected: true,
          class:
            "pseudo-button pseudo-button-very-small pseudo-button-selected pt-2 pb-2 ion-text-center"
        };
      } else {
        //
      }
    },
    async saveInfo() {
      const instance = this;
      instance.startLoading();
      const goal = instance.profile.data.goal;
      const gender = instance.profile.data.gender;
      const age = instance.profile.data.age;
      const height = instance.profile.data.height;
      let weight = instance.weight;
      const bf = instance.bf;
      const sportsFrequency = instance.profile.data.sportsFrequency;
      const sportsTime = instance.profile.data.sportsTime;
      const sportsIntensity = instance.profile.data.sportsIntensity;
      const milestoneLostWeight = instance.profile.data.milestoneLostWeight;
      const milestoneLostFat = instance.profile.data.milestoneLostFat;
      if (typeof instance.weight === "string") {
        weight = weight.replace(/\D/g, "");
      }
      let lostWeight = milestoneLostWeight || false;
      if (weight < instance.profile.data.weight) {
        lostWeight = true;
      }
      let lostFat = milestoneLostFat || false;
      if (bf === "bf1") {
        if (
          instance.profile.data.bf === "bf2" ||
          instance.profile.data.bf === "bf3" ||
          instance.profile.data.bf === "bf4"
        ) {
          lostFat = true;
        }
      } else if (bf === "bf2") {
        if (
          instance.profile.data.bf === "bf3" ||
          instance.profile.data.bf === "bf4"
        ) {
          lostFat = true;
        }
      } else if (bf === "bf3") {
        if (instance.profile.data.bf === "bf4") {
          lostFat = true;
        }
      } else {
        //
      }
      if (goal) {
        const params = {
          goal,
          gender,
          age,
          height,
          weight,
          bf,
          sportsFrequency,
          sportsTime,
          sportsIntensity
        };
        const target = calculateTargets(params);
        /*
        const calculateTargets = firebase
          .functions()
          .httpsCallable("calculateTargets");
        const target = await calculateTargets({ params: params });
        */
        if (target) {
          await db
            .collection("users")
            .doc(instance.profile.id)
            .update({
              target: target,
              gender: params.gender,
              age: params.age,
              height: params.height,
              weight: params.weight,
              bf: params.bf,
              sportsFrequency: params.sportsFrequency,
              sportsTime: params.sportsTime,
              sportsIntensity: params.sportsIntensity,
              milestoneFirstSurvey: true,
              milestoneLostWeight: lostWeight,
              milestoneLostFat: lostFat
            });
          instance.profile.data.target = target;
          instance.profile.data.gender = gender;
          instance.profile.data.age = age;
          instance.profile.data.height = height;
          instance.profile.data.weight = weight;
          instance.profile.data.bf = bf;
          instance.profile.data.sportsFrequency = sportsFrequency;
          instance.profile.data.sportsTime = sportsTime;
          instance.profile.data.sportsIntensity = sportsIntensity;
          instance.profile.data.milestoneFirstSurvey = true;
          instance.profile.data.milestoneLostWeight = lostWeight;
          instance.profile.data.milestoneLostFat = lostFat;
          store.updateProfile(instance.profile);
          instance.isLoading = false;
          instance.$router.push({
            name: "Meal Plan"
          });
        } else {
          instance.isGenerating = "d-none";
          instance.isLoading = false;
          instance.notification = {
            class: "error-message p-3",
            message:
              "Ocorreu um erro ao realizar esta operação. Por favor, tente novamente."
          };
          setTimeout(() => {
            instance.clearNotification();
          }, 3000);
        }
      } else {
        instance.isGenerating = "d-none";
        instance.isLoading = false;
        instance.notification = {
          class: "error-message p-3",
          message: "Por favor, preencha todas as informações necessárias."
        };
        setTimeout(() => {
          instance.clearNotification();
        }, 3000);
      }
    }
  },
  async created() {
    const instance = this;
    await store.signinUser();
    instance.user = store.state.user;
    instance.profile = store.state.profile;
    try {
      if (instance.profile.data.gender) {
        if (instance.profile.data.gender === "f") {
          //
        } else {
          this.bfImage1 =
            "https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/bf_man_1.png?alt=media&token=fb255aff-8b9a-4e78-9c68-422930c8d47d";
          this.bfImage2 =
            "https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/bf_man_2.png?alt=media&token=52af0de9-c9c6-44a0-8faf-6bea36b305e2";
          this.bfImage3 =
            "https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/bf_man_3.png?alt=media&token=4d9bc558-97ca-4fac-ac61-6f287312e328";
          this.bfImage4 =
            "https://firebasestorage.googleapis.com/v0/b/updiet-app.appspot.com/o/bf_man_4.png?alt=media&token=12c22d30-6e33-4c84-9c50-d676f9643379";
        }
      }
      if (instance.profile.data.weight) {
        instance.weight = instance.profile.data.weight;
      }
      if (instance.profile.data.bf) {
        instance.bf = instance.profile.data.bf;
        if (instance.profile.data.bf === "bf1") {
          instance.bf1 = {
            selected: true,
            class:
              "pseudo-button pseudo-button-very-small pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
          instance.bf2 = {
            selected: false,
            class:
              "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
          };
          instance.bf3 = {
            selected: false,
            class:
              "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
          };
          instance.bf4 = {
            selected: false,
            class:
              "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
          };
        } else if (instance.profile.data.bf === "bf2") {
          instance.bf1 = {
            selected: false,
            class:
              "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
          };
          instance.bf2 = {
            selected: true,
            class:
              "pseudo-button pseudo-button-very-small pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
          instance.bf3 = {
            selected: false,
            class:
              "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
          };
          instance.bf4 = {
            selected: false,
            class:
              "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
          };
        } else if (instance.profile.data.bf === "bf3") {
          instance.bf1 = {
            selected: false,
            class:
              "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
          };
          instance.bf2 = {
            selected: false,
            class:
              "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
          };
          instance.bf3 = {
            selected: true,
            class:
              "pseudo-button pseudo-button-very-small pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
          instance.bf4 = {
            selected: false,
            class:
              "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
          };
        } else if (instance.profile.data.bf === "bf4") {
          instance.bf1 = {
            selected: false,
            class:
              "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
          };
          instance.bf2 = {
            selected: false,
            class:
              "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
          };
          instance.bf3 = {
            selected: false,
            class:
              "pseudo-button pseudo-button-very-small pt-2 pb-2 ion-text-center"
          };
          instance.bf4 = {
            selected: true,
            class:
              "pseudo-button pseudo-button-very-small pseudo-button-selected pt-2 pb-2 ion-text-center"
          };
        } else {
          //
        }
      }
    } catch (e) {
      console.log(e);
      instance.isLoading = false;
    }
  }
};
</script>

<style scoped>
ion-content {
  --background: linear-gradient(
    180deg,
    var(--ion-color-primary),
    white
  ) !important;
}
.select-box {
  display: flex;
  justify-content: space-evenly !important;
  width: 100% !important;
}

.select-item {
  border: 1px solid lightgrey;
}
.select-sports-frequency {
  display: flex;
  align-items: center;
}
.padding-input {
  --padding-start: 8vw;
}
.bf {
  position: relative;
}
.bf-tag {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  bottom: 5px;
  left: 50%;
  transform: translate(-50%);
  width: 80%;
  height: 20px;
  z-index: 1001;
  text-align: center;
  font-size: 0.8rem;
  background: dark;
}
ion-input {
  --color: var(--bg-color-dark) !important;
}
</style>
